/**
 * @Author: wence@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 15:40:25
 * @FilePath: /m-anquan-baidu-com/src/containers/product/page_app_solution.js
 * @Description: app解决方案
 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';

import './page_app_solution.less';

export default class PageAppSolution extends PureComponent {
    static propTypes = {
        bannerInfo: PropTypes.object
    }

    render() {
        const bannerInfo = this.props.bannerInfo || {};

        return (
            <div className={'product'}>
                <div className="pro-banner-box bg-new">
                    <ProBanner
                        title={bannerInfo.title}
                        urlText={bannerInfo.urlText}
                        bgImg={bannerInfo.bgImg}
                        url={bannerInfo.url}
                    />
                    {bannerInfo.nextText ? (
                        <a href={bannerInfo.nextUrl} target="_blank" className="compliance-btn">
                            {bannerInfo.nextText}
                        </a>
                    ) : null}
                </div>

                <div className={'product-des'}>
                    基于AI和大数据技术，为APP提供从应用端到服务端的全方位防护，支持应用加固、隐私合规、内容风险检测、服务端综合防护、威胁情报和安全专家评估服务等。
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title={'适用场景'} />
                </div>
                <div className={'product-mod'} style={{paddingBottom: 0}}>
                    {
                        [
                            {
                                'mobile_pic': require('../../asset/image/page_app_solution/pic_1.png'),
                                title: '应用加固',
                                content: '防止应用被逆向、破解造成业务数据泄露、核心代码被窃取或篡改。'
                            },
                            {
                                'mobile_pic': require('../../asset/image/page_app_solution/pic_2.png'),
                                title: '隐私合规',
                                content: '支持APP隐私专项检测、场景检测和权限过度收集等检测。帮企业高效、低成本地做APP合规自查，满足监管要求。'
                            },
                            {
                                'mobile_pic': require('../../asset/image/page_app_solution/pic_3.png'),
                                title: '威胁情报',
                                content: '提供访问的终端设备、访问IP和访问内容等的风险识别和提示，帮企业做好风险访问隔离和风险内容处置，保障业务安全。'
                            },
                            {
                                'mobile_pic': require('../../asset/image/page_app_solution/pic_4.png'),
                                title: '服务端防护',
                                content: '提供包括服务端安全漏洞扫描、恶意入侵拦截和安全专家评估等服务，提升服务端的安全级别。'
                            }
                        ].map((item, index) => {
                            return <div
                                className={'pro-applicable'}
                                key={index}
                                style={{backgroundImage: `url(${item.mobile_pic})`}}
                            >
                                <div className={'pro-app-title'}>
                                    {item.title}
                                </div>
                                <div className={'pro-app-content'}>
                                    {item.content}
                                </div>
                            </div>;
                        })
                    }
                </div>


                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title="业务结构" />
                </div>

                <img
                    src={require('../../asset/image/page_app_solution/tree.png')}
                    style={{width: '10rem', margin: '0 auto'}}
                    alt={''}
                />

                <div className={'product-mod'} style={{marginTop: '1rem'}}>
                    <ProductTitle title="方案优势" />
                </div>
                <div className="saas-p-advantage">
                    {
                        [
                            {
                                title: '全面防护',
                                des: '覆盖APP的服务端和应用端。安全防护问题一站式解决。',
                                url: require('../../asset/image/page_app_solution/icon_quanmianfanghu.svg')
                            },
                            {
                                title: '按需定制',
                                des: '企业可以根据自身的安全需求，选择采用解决方案中的部分安全能力。',
                                url: require('../../asset/image/page_app_solution/icon_anxudingzhi.svg')
                            },
                            {
                                title: '适用面广',
                                des: '适用各种类型的APP，包括电商、金融、视频、资讯、社交和教育等。',
                                url: require('../../asset/image/page_app_solution/icon_shiyongmianguang.svg')
                            },
                            {
                                title: '有效保护',
                                des: '基于百度核心技术研发，服务多个核心产品线和外部客户，服务能力已被有效验证。',
                                url: require('../../asset/image/page_app_solution/icon_youxiaofanghu.svg')
                            }
                        ].map((item, index) => {
                            return (
                                <div key={index} className="saas-p-advantage-item">
                                    <div className="icon" style={{backgroundImage: `url(${item.url})`}}></div>
                                    <div className="content">
                                        <div className="title">{item.title}</div>
                                        <div className="des">{item.des}</div>
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>

                <div className={'product-mod'}>
                    <ProductTitle title="合作客户" />
                </div>

                <div style={{width: '100%', marginBottom: '1rem'}}>
                    <img width="100%" src={require('../../asset/image/page_app_solution/logo-wap.png')} alt={''}/>
                </div>

                <div style={{background: '#F5F5F5', paddingBottom: '1rem'}}>
                    <div className={'product-mod'} style={{paddingTop: '1rem'}}>
                        <ProductTitle title="相关产品" />
                    </div>
                    <div>
                        {
                            [
                                {
                                    title: '安全OTA',
                                    content: `百度安全OTA是百度利用积累多年的云管端安全能力打造的安全OTA方案，
                                    集成了百度多项安全专利技术，旨在为智能设备提供安全、高效的系统升级方案，支持Android、Linux及嵌入式系统设备，
                                    提供云端设备管理平台及设备端SDK，接入简单便捷，可视化管理零门槛。`,
                                    url: 'https://anquan.baidu.com/page/29'
                                },
                                {
                                    title: '图数据库',
                                    content: `HugeGraph是一款易用、高效、通用的图数据库，
                                    实现了Apache TinkerPop3框架及兼容Gremlin查询语言。支持百亿以上的顶点(Vertex)和边(Edge)快速导入，
                                    并提供毫秒级的关联查询能力，并可与Hadoop、Spark等大数据平台集成以进行离线分析。
                                    主要应用场景包括关联分析、欺诈检测和知识图谱等。`,
                                    url: 'https://anquan.baidu.com/page/27'
                                },
                                {
                                    title: '云手机',
                                    content: `百度云手机是依托公有云和ARM虚拟化技术，最终为用户/客户在云端提供的一个个安卓实例（操作系统）。
                                    用户/客户可以通过视频流的方式，远程实时控制云手机，
                                    最终实现安卓原生APP及手游的云端运行。`,
                                    url: 'https://anquan.baidu.com/page/59'
                                }
                            ].map((item, index) => {
                                return (
                                    <div key={index} className="saas-app-solution-card">
                                        <div className="title">{item.title}</div>
                                        <div className="content">{item.content}</div>
                                        <a href={item.url} target="_blank" className="btn">了解详情</a>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>

                <div className="saas-app-solution-contact">
                    <div className="saas-app-solution-contact-inner">
                        <div className="des">
                            如果您对产品和方案的适用场景或技术架构等<br/>方面有问题，欢迎随时联系我们。
                        </div>
                        <a href={bannerInfo.url} className="btn" >
                            商务咨询
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/product/page_app_solution.js